/** The first `fraction` of a sentence's words, keeping its spacing. */
export const leadingWords = (raw, fraction) => {
  if (fraction >= 1) return raw;
  const tokens = raw.split(/(\s+)/);
  const total = tokens.filter(token => token.trim()).length;
  let remaining = Math.ceil(total * fraction);

  let text = '';
  for (const token of tokens) {
    if (token.trim()) {
      if (remaining === 0) break;
      remaining--;
    }
    text += token;
  }
  return text;
};

/**
 * The words of a sentence as a caption shows them: Markdown markers and
 * bullet dashes dropped, only the first `fraction` of the words said so far.
 */
export const captionWords = (raw, fraction) =>
  leadingWords(
    raw.replace(/^\s*[*-]\s+/gm, '').replace(/[*#`]/g, '').replace(/\s+/g, ' ').trim(),
    fraction
  ).split(' ').filter(Boolean);
